var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualAnnotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.73878,
    y: 13.6743,
    width: 102.498,
    height: 85.415
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.69px)",
      clipPath: "url(#bgblur_0_9890_4829_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 11.3887,
    x: 19.1274,
    y: 25.063,
    width: 79.7206,
    height: 62.6376,
    rx: 17.083,
    fill: "url(#paint0_linear_9890_4829)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7339,
    y: 42.6252,
    width: 79.375,
    height: 61.875,
    rx: 15.625,
    fill: "url(#paint1_linear_9890_4829)",
    stroke: "white",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9890_4829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5949 96.1078C75.0433 96.0343 72.1828 93.0586 72.2588 89.5216C72.3372 85.9062 75.3154 83.0727 78.9479 83.161C82.4873 83.2468 85.262 86.1955 85.2032 89.8109C85.1443 93.3454 82.1687 96.1838 78.5949 96.1078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6415 66.9517C75.0947 66.9027 72.2122 63.9491 72.2539 60.4072C72.298 56.8065 75.2834 53.9289 78.8989 54C82.4456 54.0686 85.2546 57.01 85.2056 60.6033C85.1566 64.155 82.2152 67.0007 78.6415 66.9517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4923 81.5163C80.899 81.504 78.0557 78.6583 78.0508 75.0674C78.0459 71.4789 80.8892 68.6136 84.4703 68.594C88.0857 68.5768 91.0417 71.5255 91.0001 75.1066C90.9559 78.6779 88.0612 81.5261 84.4923 81.5163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6425 74.136C58.3044 74.136 60.6575 74.136 63.0105 74.136C63.3782 74.136 63.7459 74.1163 64.1111 74.1507C64.8195 74.2144 65.2754 74.6066 65.246 75.3296C65.2215 75.9939 64.7655 76.3567 64.1062 76.364C62.7311 76.3836 61.356 76.3689 59.8462 76.3689C60.3364 77.2979 60.1893 77.8371 59.6648 78.6901C59.2603 79.3495 59.7432 80.6388 58.5814 81.1927C58.6672 81.33 58.7824 81.4599 58.8338 81.6094C59.1206 82.4502 58.7382 83.1169 57.8411 83.1438C55.6449 83.21 53.4316 83.335 51.3726 82.2761C50.5711 81.8643 49.7157 81.5702 48.7891 81.6511C48.2131 81.7001 47.9876 81.4795 47.9974 80.8912C48.0219 79.2612 48.0268 77.6288 47.9974 75.9988C47.9876 75.435 48.1739 75.1801 48.7426 75.1458C49.8995 75.0796 50.8383 74.511 51.6594 73.7462C53.233 72.2829 54.9684 71.1162 57.0862 70.5843C57.5225 70.474 57.9637 70.2166 58.3191 70.6652C58.6328 71.0622 58.4809 71.5133 58.3093 71.9397C57.8779 73.0403 56.6744 73.2021 55.6425 74.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6309 83.6488C69.805 82.6977 69.3123 82.1609 68.5108 81.5972C67.746 81.0579 67.0474 80.4255 66.3391 79.8127C66.1552 79.6534 65.7753 79.499 66.1038 79.146C66.4126 78.8151 66.6111 79.1313 66.8146 79.2956C67.5769 79.9083 68.3661 80.4942 69.077 81.1633C69.7657 81.8129 70.3368 82.0457 70.8638 80.8888C71.56 81.9036 71.6972 83.0041 72.2561 84.0532C70.9913 84.2027 69.9471 83.7738 68.6309 83.6488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.729 66.5326C69.9203 66.2458 70.9791 66.0178 72.2317 65.9835C71.815 67.089 71.4375 68.0915 70.9914 69.2827C70.31 68.0915 69.6948 68.3219 68.9692 69.0376C68.2756 69.7215 67.4691 70.2901 66.7142 70.9127C66.5157 71.077 66.3245 71.2216 66.0941 70.9593C65.8465 70.6774 66.0745 70.523 66.2558 70.371C67.0059 69.7435 67.7241 69.067 68.528 68.5155C69.359 67.9371 69.7511 67.3856 68.729 66.5326Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9890_4829_clip_path",
    transform: "translate(-7.73878 -13.6743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.1274,
    y: 25.063,
    width: 79.7206,
    height: 62.6376,
    rx: 17.083
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9890_4829",
    x1: 42.1238,
    y1: 38.765,
    x2: 105.278,
    y2: 66.8512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F4690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9890_4829",
    x1: 69.4214,
    y1: 42.0002,
    x2: 69.4214,
    y2: 105.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9890_4829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42.1102,
    fill: "white",
    transform: "translate(48 54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualAnnotate);
export default __webpack_public_path__ + "static/media/manual_annotate.ac6a19b52678bac77e3808ee15167770.svg";
export { ForwardRef as ReactComponent };